import React from "react";
import { Card } from "react-bootstrap";
import { Notify } from "components/Alerts/Alert";
import { Button } from "@material-ui/core";

const PwdSecurity = () => {
	return (
		<>
			{/* Title */}
			<h3 className="title-primary d-none d-md-block">Password & Security</h3>

			{/* Password */}
			<Card body className="mb-3">
				<Card.Title className="row g-0 justify-content-between align-items-center">Password</Card.Title>
				<hr />
				<Notify icon={<i className="fas fa-key"></i>}>
					<Notify.Body>
						<h6>Password has been set</h6>
						<small className="text-gray-light">Choose a strong, unique password that's at least 8 characters long.</small>
					</Notify.Body>
					<Notify.Action>
						<Button variant="contained" color="primary" disableElevation>
							Edit
						</Button>
					</Notify.Action>
				</Notify>
			</Card>

			{/* Two-factor auth */}
			<Card body className="mb-3">
				<Card.Title className="row g-0 justify-content-between align-items-center">Two-Factor Authentication</Card.Title>
				<hr />
				{/* Content */}
				<Notify icon={<i className="fas fa-shield-alt"></i>} className="mb-3">
					<Notify.Body>
						<h6>Authenticator app code</h6>
						<small className="text-gray-light">Enter a code generated by your authenticator app to confirm it's you.</small>
					</Notify.Body>
					<Notify.Action>
						<Button variant="contained" color="primary" disableElevation>
							Enable
						</Button>
					</Notify.Action>
				</Notify>

				<Notify icon={<i className="fas fa-mobile-alt"></i>} className="mb-3">
					<Notify.Body>
						<h6>Mobile app prompt</h6>
						<small className="text-gray-light">Receive a prompt from your mobile app to confirm it's you.</small>
					</Notify.Body>
					<Notify.Action>
						<Button variant="contained" color="primary" disableElevation>
							Enable
						</Button>
					</Notify.Action>
				</Notify>

				<Notify icon={<i className="fas fa-comment-alt"></i>}>
					<Notify.Body>
						<h6>Text Message</h6>
						<small className="text-gray-light">Receive a six digit code by text message to confirm it's you.</small>
					</Notify.Body>
					<Notify.Action>
						<Button variant="contained" color="primary" disableElevation>
							Enable
						</Button>
					</Notify.Action>
				</Notify>
			</Card>
			{/* Extra security */}
			<Card body>
				<Card.Title className="row g-0 justify-content-between align-items-center">Extra Security</Card.Title>
				<hr />
				{/* Content */}
				<Notify icon={<i className="fas fa-question-circle"></i>}>
					<Notify.Body>
						<h6>Security Questions</h6>
						<small className="text-gray-light">Answer a question you choose to confirm it's you.</small>
					</Notify.Body>
					<Notify.Action>
						<Button variant="contained" color="primary" disableElevation>
							Enable
						</Button>
					</Notify.Action>
				</Notify>
			</Card>
		</>
	);
};

export default PwdSecurity;
